var _style, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderThinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-20 -20 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    circle { animation: 4s a infinite linear, 3s o infinite linear; }\n    @keyframes a {\n      from {stroke-dasharray:100 0}\n      75% {stroke-dasharray:0 100}\n      to {stroke-dasharray:100 0}\n    }\n    @keyframes o {\n      from {stroke-dashoffset:75}\n      to{stroke-dashoffset:375}\n    }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 15.9154943092,
    strokeWidth: 3,
    fill: "none",
    stroke: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderThinWhite);
export default __webpack_public_path__ + "static/media/loader_thin_white.98721f803c16605a1121faa4fd2a7e75.svg";
export { ForwardRef as ReactComponent };